import firebase from "firebase";
import { withLog } from "../../logger/with_log";

export default {
  storageRef(path) {
    return firebase.storage().ref(path);
  },

  DeploymentProgressRef() {
    return firebase.firestore().collection("Deployment_progress");
  },

  async getAll() {
    return withLog(() => this.DeploymentProgressRef().get());
  },

  async downloadPeriodicInformation(
    file,
    storage = "Deployment_progress",
    type = undefined
  ) {
    const operationalDeployment = this.storageRef(storage);

    operationalDeployment
      .child(file)
      .getDownloadURL()
      .then(function(url) {
        const xhr = new XMLHttpRequest();
        xhr.responseType = "blob";
        xhr.onload = function() {
          const a = document.createElement("a");

          a.href = window.URL.createObjectURL(xhr.response);
          a.download = file;
          if (type) {
            a.download = file + type;
          }
          a.style.display = "none";
          document.body.appendChild(a);
          a.click();
        };
        xhr.open("GET", url);
        xhr.send();
      });
  }
  // async getAll() {
  //   try {
  //     const snapshot = await this.DeploymentProgressRef().get();
  //     if (snapshot.empty) {
  //       return [];
  //     }

  //     return snapshot.docs.map((value) => ({
  //       id: value.id,
  //       ...value.data(),
  //     }));
  //   } catch (error) {
  //     console.error('periodicInformation fnd all error', error);
  //   }
  // },
};
